var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-select-buttons',{attrs:{"items":_vm.pointOptionList,"value":_vm.value,"error-messages":_vm.errors,"size":"1/1","pc-size":"1/5"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }